{
  "username": "用户名",
  "password": "密码",
  "login": "登录",
  "confirm": "确定",
  "cancel": "取消",
  "close": "关闭",
  "save": "保存",
  "logout": "登出",
  "create": "创建",
  "add": "添加",
  "remove": "移除",
  "update": "更新",
  "copy": "复制",
  "copied": "已复制",
  "more": "更多",
  "download": "下载",
  "remark": "备注",
  "enable": "启用",
  "protocol": "协议",
  "search": "搜索",
  "filter": "筛选",
  "all": "全部",
  "from": "从",
  "to": "到",
  "done": "完成",
  "loading": "加载中...",
  "refresh": "刷新",
  "clear": "清除",
  "second": "秒",
  "minute": "分钟",
  "hour": "小时",
  "day": "天",
  "check": "查看",
  "indefinite": "无限期",
  "unlimited": "无限制",
  "none": "无",
  "qrCode": "二维码",
  "info": "更多信息",
  "edit": "编辑",
  "delete": "删除",
  "reset": "重置",
  "noData": "无数据。",
  "copySuccess": "复制成功",
  "sure": "确定",
  "encryption": "加密",
  "useIPv4ForHost": "使用 IPv4 连接主机",
  "transmission": "传输",
  "host": "主机",
  "path": "路径",
  "camouflage": "混淆",
  "status": "状态",
  "enabled": "开启",
  "disabled": "关闭",
  "depleted": "耗尽",
  "depletingSoon": "即将耗尽",
  "offline": "离线",
  "online": "在线",
  "domainName": "域名",
  "monitor": "监听",
  "certificate": "数字证书",
  "fail": "失败",
  "comment": "评论",
  "success": "成功",
  "lastOnline": "上次在线",
  "getVersion": "获取版本",
  "install": "安装",
  "clients": "客户端",
  "usage": "使用情况",
  "twoFactorCode": "代码",
  "remained": "剩余",
  "security": "安全",
  "secAlertTitle": "安全警报",
  "secAlertSsl": "此连接不安全。在激活 TLS 进行数据保护之前，请勿输入敏感信息。",
  "secAlertConf": "某些设置易受攻击。建议加强安全协议以防止潜在漏洞。",
  "secAlertSSL": "面板缺少安全连接。请安装 TLS 证书以保护数据安全。",
  "secAlertPanelPort": "面板默认端口存在安全风险。请配置随机端口或特定端口。",
  "secAlertPanelURI": "面板默认 URI 路径不安全。请配置复杂的 URI 路径。",
  "secAlertSubURI": "订阅默认 URI 路径不安全。请配置复杂的 URI 路径。",
  "secAlertSubJsonURI": "订阅 JSON 默认 URI 路径不安全。请配置复杂的 URI 路径。",
  "emptyDnsDesc": "未添加DNS服务器。",
  "emptyFakeDnsDesc": "未添加Fake DNS服务器。",
  "emptyBalancersDesc": "未添加负载均衡器。",
  "emptyReverseDesc": "未添加反向代理。",
  "somethingWentWrong": "出了点问题",
  "subscription": {
    "title": "订阅信息",
    "subId": "订阅 ID",
    "status": "状态",
    "downloaded": "已下载",
    "uploaded": "已上传",
    "expiry": "到期",
    "totalQuota": "总配额",
    "individualLinks": "单独链接",
    "active": "启用",
    "inactive": "停用",
    "unlimited": "无限制",
    "noExpiry": "无到期"
  },
  "menu": {
    "theme": "主题",
    "dark": "暗色",
    "ultraDark": "超暗色",
    "dashboard": "系统状态",
    "inbounds": "入站",
    "clients": "客户端",
    "groups": "分组",
    "nodes": "节点",
    "settings": "面板设置",
    "xray": "Xray 配置",
    "apiDocs": "API 文档",
    "logout": "退出登录",
    "link": "管理",
    "donate": "捐赠"
  },
  "pages": {
    "login": {
      "hello": "你好",
      "title": "欢迎",
      "loginAgain": "登录时效已过，请重新登录",
      "toasts": {
        "invalidFormData": "数据格式错误",
        "emptyUsername": "请输入用户名",
        "emptyPassword": "请输入密码",
        "wrongUsernameOrPassword": "用户名、密码或双重验证码无效。",
        "successLogin": "您已成功登录您的账户。"
      }
    },
    "index": {
      "title": "系统状态",
      "cpu": "CPU",
      "logicalProcessors": "逻辑处理器",
      "frequency": "频率",
      "swap": "Swap",
      "storage": "存储",
      "memory": "RAM",
      "threads": "线程",
      "xrayStatus": "Xray",
      "stopXray": "停止",
      "restartXray": "重启",
      "xraySwitch": "版本",
      "xrayUpdates": "Xray 更新",
      "xraySwitchClick": "选择你要切换到的版本",
      "xraySwitchClickDesk": "请谨慎选择，因为较旧版本可能与当前配置不兼容",
      "updatePanel": "更新面板",
      "panelUpdateDesc": "这将把 3X-UI 更新到最新版本并重启面板服务。",
      "currentPanelVersion": "当前面板版本",
      "latestPanelVersion": "最新面板版本",
      "panelUpToDate": "面板已是最新",
      "upToDate": "已是最新",
      "xrayStatusUnknown": "未知",
      "xrayStatusRunning": "运行中",
      "xrayStatusStop": "停止",
      "xrayStatusError": "错误",
      "xrayErrorPopoverTitle": "运行Xray时发生错误",
      "operationHours": "系统正常运行时间",
      "systemHistoryTitle": "系统历史",
      "charts": "图表",
      "xrayMetricsTitle": "Xray 指标",
      "xrayMetricsDisabled": "未配置 Xray 指标端点",
      "xrayMetricsHint": "在 xray 配置中添加顶级 metrics 块,tag 为 metrics_out,listen 为 127.0.0.1:11111,然后重启 xray。",
      "xrayObservatoryEmpty": "暂无 Observatory 数据",
      "xrayObservatoryHint": "在 xray 配置中添加 observatory 块,列出要探测的出站 tag,然后重启 xray。",
      "xrayObservatoryTagPlaceholder": "选择出站",
      "xrayObservatoryAlive": "在线",
      "xrayObservatoryDead": "离线",
      "xrayObservatoryLastSeen": "最后在线",
      "xrayObservatoryLastTry": "最后尝试",
      "trendLast2Min": "最近 2 分钟",
      "systemLoad": "系统负载",
      "systemLoadDesc": "过去 1、5 和 15 分钟的系统平均负载",
      "connectionCount": "连接数",
      "ipAddresses": "IP地址",
      "toggleIpVisibility": "切换IP可见性",
      "overallSpeed": "整体速度",
      "upload": "上传",
      "download": "下载",
      "totalData": "总数据",
      "sent": "已发送",
      "received": "已接收",
      "documentation": "文档",
      "xraySwitchVersionDialog": "您确定要更改Xray版本吗？",
      "xraySwitchVersionDialogDesc": "这将把Xray版本更改为#version#。",
      "xraySwitchVersionPopover": "Xray 更新成功",
      "panelUpdateDialog": "您确定要更新面板吗？",
      "panelUpdateDialogDesc": "这将把 3X-UI 更新到 #version# 并重启面板服务。",
      "panelUpdateCheckPopover": "面板更新检查失败",
      "panelUpdateStartedPopover": "已开始更新面板",
      "geofileUpdateDialog": "您确定要更新地理文件吗？",
      "geofileUpdateDialogDesc": "这将更新 #filename# 文件。",
      "geofilesUpdateDialogDesc": "这将更新所有文件。",
      "geofilesUpdateAll": "全部更新",
      "geofileUpdatePopover": "地理文件更新成功",
      "customGeoTitle": "自定义 GeoSite / GeoIP",
      "customGeoAdd": "添加",
      "customGeoType": "类型",
      "customGeoAlias": "别名",
      "customGeoUrl": "URL",
      "customGeoEnabled": "启用",
      "customGeoLastUpdated": "上次更新",
      "customGeoExtColumn": "路由 (ext:…)",
      "customGeoToastUpdateAll": "所有自定义来源已更新",
      "customGeoActions": "操作",
      "customGeoEdit": "编辑",
      "customGeoDelete": "删除",
      "customGeoDownload": "立即更新",
      "customGeoModalAdd": "添加自定义 geo",
      "customGeoModalEdit": "编辑自定义 geo",
      "customGeoModalSave": "保存",
      "customGeoDeleteConfirm": "删除此自定义 geo 源？",
      "customGeoRoutingHint": "在路由规则中将值列写为 ext:文件.dat:标签（替换标签）。",
      "customGeoInvalidId": "无效的资源 ID",
      "customGeoAliasesError": "加载自定义 geo 别名失败",
      "customGeoValidationAlias": "别名只能包含小写字母、数字、- 和 _",
      "customGeoValidationUrl": "URL 必须以 http:// 或 https:// 开头",
      "customGeoAliasPlaceholder": "a-z 0-9 _ -",
      "customGeoAliasLabelSuffix": "（自定义）",
      "customGeoToastList": "自定义 geo 列表",
      "customGeoToastAdd": "添加自定义 geo",
      "customGeoToastUpdate": "更新自定义 geo",
      "customGeoToastDelete": "自定义 geofile「{{ .fileName }}」已删除",
      "customGeoToastDownload": "geofile「{{ .fileName }}」已更新",
      "customGeoErrInvalidType": "类型必须是 geosite 或 geoip",
      "customGeoErrAliasRequired": "请填写别名",
      "customGeoErrAliasPattern": "别名包含不允许的字符",
      "customGeoErrAliasReserved": "该别名已保留",
      "customGeoErrUrlRequired": "请填写 URL",
      "customGeoErrInvalidUrl": "URL 无效",
      "customGeoErrUrlScheme": "URL 必须使用 http 或 https",
      "customGeoErrUrlHost": "URL 主机无效",
      "customGeoErrDuplicateAlias": "此类型下已使用该别名",
      "customGeoErrNotFound": "未找到自定义 geo 源",
      "customGeoErrDownload": "下载失败",
      "customGeoErrUpdateAllIncomplete": "有一个或多个自定义 geo 源更新失败",
      "customGeoEmpty": "暂无自定义 geo 源 — 点击「添加」以创建",
      "dontRefresh": "安装中，请勿刷新此页面",
      "logs": "日志",
      "config": "配置",
      "backup": "备份",
      "backupTitle": "备份和恢复",
      "exportDatabase": "备份",
      "exportDatabaseDesc": "点击下载包含当前数据库备份的 .db 文件到您的设备。",
      "importDatabase": "恢复",
      "importDatabaseDesc": "点击选择并上传设备中的 .db 文件以从备份恢复数据库。",
      "importDatabaseSuccess": "数据库导入成功",
      "importDatabaseError": "导入数据库时出错",
      "readDatabaseError": "读取数据库时出错",
      "getDatabaseError": "检索数据库时出错",
      "getConfigError": "检索配置文件时出错"
    },
    "inbounds": {
      "title": "入站",
      "totalDownUp": "总上传 / 下载",
      "totalUsage": "总用量",
      "inboundCount": "入站数量",
      "operate": "菜单",
      "enable": "启用",
      "remark": "备注",
      "node": "节点",
      "deployTo": "部署到",
      "localPanel": "本地面板",
      "fallbacks": {
        "title": "Fallbacks",
        "help": "当此入站的连接未匹配任何客户端时，将其路由到另一个入站。在下方选择一个子入站，路由字段（SNI / ALPN / Path / xver）会从子入站的传输方式中自动填充——大多数场景无需再调整。每个子入站应监听 127.0.0.1，security=none。",
        "empty": "暂无回落",
        "add": "添加回落",
        "pickInbound": "选择一个入站",
        "matchAny": "任意",
        "destPlaceholder": "自动（子入站 listen:port）",
        "rederive": "从子入站重新填充",
        "rederived": "已从子入站重新填充",
        "editAdvanced": "编辑路由字段",
        "hideAdvanced": "隐藏高级",
        "quickAddAll": "一键添加所有可用入站",
        "quickAdded": "已添加 {n} 条回落",
        "quickAddedNone": "没有可添加的新入站",
        "routesWhen": "当满足条件时路由",
        "defaultCatchAll": "默认 — 兜底匹配其他所有"
      },
      "protocol": "协议",
      "port": "端口",
      "portMap": "端口映射",
      "traffic": "流量",
      "details": "详细信息",
      "transportConfig": "传输",
      "expireDate": "到期时间",
      "createdAt": "创建时间",
      "updatedAt": "更新时间",
      "resetTraffic": "重置流量",
      "addInbound": "添加入站",
      "generalActions": "通用操作",
      "modifyInbound": "修改入站",
      "deleteInbound": "删除入站",
      "deleteInboundContent": "确定要删除入站吗？",
      "deleteConfirmTitle": "删除入站 \"{remark}\"？",
      "deleteConfirmContent": "将删除此入站及其所有客户端。该操作不可撤销。",
      "resetConfirmTitle": "重置 \"{remark}\" 的流量？",
      "resetConfirmContent": "将此入站的上/下行计数器清零。",
      "cloneConfirmTitle": "克隆入站 \"{remark}\"？",
      "cloneConfirmContent": "使用新端口和空客户端列表创建副本。",
      "delAllClients": "删除所有客户端",
      "delAllClientsConfirmTitle": "从 \"{remark}\" 中删除全部 {count} 个客户端？",
      "delAllClientsConfirmContent": "从此入站中移除每个客户端并丢弃其流量记录。入站本身将保留。此操作无法撤销。",
      "attachClients": "附加客户端到…",
      "addClientsToGroup": "将客户端添加到分组…",
      "attachClientsTitle": "从 “{remark}” 附加客户端",
      "attachClientsDesc": "将相同的 {count} 个客户端(相同 UUID/密码和共享流量)附加到选定的入站。它们仍保留在此入站中。",
      "attachClientsTargets": "目标入站",
      "attachClientsNoTargets": "没有可附加的其他兼容入站。",
      "attachClientsResult": "已附加 {attached},已跳过 {skipped}。",
      "attachClientsResultMixed": "已附加 {attached},已跳过 {skipped},错误 {errors}。",
      "attachClientsSelectLabel": "要附加的客户端",
      "attachClientsSearchPlaceholder": "搜索邮箱或备注",
      "attachClientsStatusDisabled": "已禁用",
      "attachClientsSelectedCount": "已选 {selected}/{total}",
      "detachClients": "分离客户端",
      "detachClientsTitle": "从 “{remark}” 分离客户端",
      "detachClientsDesc": "仅从此入站移除选中的客户端。客户端记录保留(使用 Delete 完全移除)。源共有 {count} 个客户端。",
      "detachClientsResult": "已分离 {detached},已跳过 {skipped}。",
      "detachClientsResultMixed": "已分离 {detached},已跳过 {skipped},错误 {errors}。",
      "detachClientsSelectLabel": "要分离的客户端",
      "exportLinksTitle": "导出入站链接",
      "exportSubsTitle": "导出订阅链接",
      "exportAllLinksTitle": "导出所有入站链接",
      "exportAllSubsTitle": "导出所有订阅链接",
      "exportAllLinksFileName": "所有入站",
      "exportAllSubsFileName": "所有入站-Subs",
      "inboundJsonTitle": "入站 JSON",
      "deleteClient": "删除客户端",
      "deleteClientContent": "确定要删除客户端吗？",
      "resetTrafficContent": "确定要重置流量吗？",
      "copyLink": "复制链接",
      "address": "地址",
      "network": "网络",
      "destinationPort": "目标端口",
      "targetAddress": "目标地址",
      "monitorDesc": "留空表示监听所有 IP",
      "meansNoLimit": "= 无限制。(单位: GB)",
      "totalFlow": "总流量",
      "leaveBlankToNeverExpire": "留空表示永不过期",
      "noRecommendKeepDefault": "建议保留默认值",
      "certificatePath": "文件路径",
      "certificateContent": "文件内容",
      "publicKey": "公钥",
      "privatekey": "私钥",
      "clickOnQRcode": "点击二维码复制",
      "client": "客户",
      "export": "导出链接",
      "clone": "克隆",
      "cloneInbound": "克隆",
      "cloneInboundContent": "此入站规则除端口（Port）、监听 IP（Listening IP）和客户端（Clients）以外的所有配置都将应用于克隆",
      "cloneInboundOk": "创建克隆",
      "resetAllTraffic": "重置所有入站流量",
      "resetAllTrafficTitle": "重置所有入站流量",
      "resetAllTrafficContent": "确定要重置所有入站流量吗？",
      "resetInboundClientTraffics": "重置客户端流量",
      "resetInboundClientTrafficTitle": "重置所有客户端流量",
      "resetInboundClientTrafficContent": "确定要重置此入站客户端的所有流量吗？",
      "resetAllClientTraffics": "重置所有客户端流量",
      "resetAllClientTrafficTitle": "重置所有客户端流量",
      "resetAllClientTrafficContent": "确定要重置所有客户端的所有流量吗？",
      "delDepletedClients": "删除流量耗尽的客户端",
      "delDepletedClientsTitle": "删除流量耗尽的客户端",
      "delDepletedClientsContent": "确定要删除所有流量耗尽的客户端吗？",
      "email": "邮箱",
      "emailDesc": "电子邮件必须完全唯一",
      "IPLimit": "IP 限制",
      "IPLimitDesc": "如果数量超过设置值，则禁用入站流量。（0 = 禁用）",
      "IPLimitlog": "IP 日志",
      "IPLimitlogDesc": "IP 历史日志（要启用被禁用的入站流量，请清除日志）",
      "IPLimitlogclear": "清除日志",
      "setDefaultCert": "从面板设置证书",
      "setDefaultCertEmpty": "面板尚未配置证书。请先在“设置”中设置。",
      "streamTab": "传输",
      "securityTab": "安全",
      "sniffingTab": "嗅探",
      "sniffingMetadataOnly": "仅元数据",
      "sniffingRouteOnly": "仅路由",
      "sniffingIpsExcluded": "排除的 IP",
      "sniffingDomainsExcluded": "排除的域名",
      "decryption": "解密",
      "encryption": "加密",
      "vlessAuthX25519": "X25519 认证",
      "vlessAuthMlkem768": "ML-KEM-768 认证",
      "vlessAuthCustom": "自定义",
      "vlessAuthSelected": "已选择：{auth}",
      "advanced": {
        "title": "入站 JSON 部分",
        "subtitle": "完整入站 JSON 以及针对 settings、sniffing 和 streamSettings 的专用编辑器。",
        "all": "全部",
        "allHelp": "在单个编辑器中编辑包含所有字段的完整入站对象。",
        "settings": "设置",
        "settingsHelp": "Xray settings 块包装：",
        "sniffing": "Sniffing",
        "sniffingHelp": "Xray sniffing 块包装：",
        "stream": "Stream",
        "streamHelp": "Xray stream 块包装：",
        "jsonErrorPrefix": "高级 JSON"
      },
      "telegramDesc": "请提供Telegram聊天ID。（在机器人中使用'/id'命令）或（{'@'}userinfobot",
      "subscriptionDesc": "要找到你的订阅 URL，请导航到“详细信息”。此外，你可以为多个客户端使用相同的名称。",
      "same": "相同",
      "inboundData": "入站数据",
      "exportInbound": "导出入站规则",
      "import": "导入",
      "importInbound": "导入入站规则",
      "periodicTrafficResetTitle": "流量重置",
      "periodicTrafficResetDesc": "按指定间隔自动重置流量计数器",
      "lastReset": "上次重置",
      "periodicTrafficReset": {
        "never": "从不",
        "daily": "每日",
        "weekly": "每周",
        "monthly": "每月",
        "hourly": "每小时"
      },
      "toasts": {
        "obtain": "获取",
        "updateSuccess": "更新成功",
        "logCleanSuccess": "日志已清除",
        "inboundsUpdateSuccess": "入站连接已成功更新",
        "inboundUpdateSuccess": "入站连接已成功更新",
        "inboundCreateSuccess": "入站连接已成功创建",
        "inboundDeleteSuccess": "入站连接已成功删除",
        "inboundClientAddSuccess": "已添加入站客户端",
        "inboundClientDeleteSuccess": "入站客户端已删除",
        "inboundClientUpdateSuccess": "入站客户端已更新",
        "delDepletedClientsSuccess": "所有耗尽客户端已删除",
        "resetAllClientTrafficSuccess": "客户端所有流量已重置",
        "resetAllTrafficSuccess": "所有流量已重置",
        "resetInboundClientTrafficSuccess": "流量已重置",
        "resetInboundTrafficSuccess": "入站流量已重置",
        "trafficGetError": "获取流量数据时出错",
        "getNewX25519CertError": "获取X25519证书时出错。",
        "getNewmldsa65Error": "获取mldsa65证书时出错。",
        "getNewVlessEncError": "获取VlessEnc证书时出错。"
      },
      "form": {
        "moveUp": "上移",
        "moveDown": "下移",
        "addAll": "全部添加",
        "addAllFallbackTooltip": "为尚未连接的每个符合条件的入站添加一个 fallback 行",
        "peers": "Peers",
        "addPeer": "添加 peer",
        "keepAlive": "Keep-alive",
        "autoSystemRoutesTooltip": "仅 Windows。CIDR 会自动添加到系统路由表,以便匹配的流量通过 TUN。",
        "autoOutboundsInterface": "自动出站接口",
        "autoOutboundsInterfaceTooltip": "出站流量的物理接口。使用 'auto' 进行检测;设置 Auto system routes 时自动启用。",
        "rewriteAddress": "重写地址",
        "rewritePort": "重写端口",
        "allowedNetwork": "允许的网络",
        "followRedirect": "跟随重定向",
        "accounts": "账户",
        "allowTransparent": "允许透明",
        "encryptionMethod": "加密方法",
        "visionTestseed": "Vision testseed",
        "version": "版本",
        "udpIdleTimeout": "UDP 空闲超时 (s)",
        "masquerade": "伪装",
        "type": "类型",
        "upstreamUrl": "Upstream URL",
        "rewriteHost": "重写 Host",
        "skipTlsVerify": "跳过 TLS 验证",
        "directory": "目录",
        "statusCode": "状态码",
        "body": "Body",
        "headers": "请求头",
        "proxyProtocol": "Proxy Protocol",
        "requestVersion": "请求版本",
        "requestMethod": "请求方法",
        "requestPath": "请求路径",
        "requestHeaders": "请求头",
        "responseVersion": "响应版本",
        "responseStatus": "响应状态",
        "responseReason": "响应原因",
        "responseHeaders": "响应头",
        "heartbeatPeriod": "心跳周期",
        "serviceName": "服务名",
        "authority": "Authority",
        "multiMode": "多模式",
        "maxBufferedUpload": "最大缓冲上传",
        "maxUploadSize": "最大上传大小 (字节)",
        "streamUpServer": "Stream-Up 服务器",
        "serverMaxHeaderBytes": "服务器最大头字节",
        "paddingBytes": "Padding 字节",
        "uplinkHttpMethod": "Uplink HTTP 方法",
        "paddingObfsMode": "Padding 混淆模式",
        "paddingKey": "Padding Key",
        "paddingHeader": "Padding Header",
        "paddingPlacement": "Padding 位置",
        "paddingMethod": "Padding 方法",
        "sessionPlacement": "Session 位置",
        "sessionKey": "Session Key",
        "sequencePlacement": "Sequence 位置",
        "sequenceKey": "Sequence Key",
        "uplinkDataPlacement": "Uplink 数据位置",
        "uplinkDataKey": "Uplink 数据 Key",
        "noSseHeader": "无 SSE 头",
        "ttiMs": "TTI (ms)",
        "uplinkMbps": "上行 (MB/s)",
        "downlinkMbps": "下行 (MB/s)",
        "cwndMultiplier": "CWND 倍数",
        "maxSendingWindow": "最大发送窗口",
        "externalProxy": "外部代理",
        "sniPlaceholder": "SNI (默认为 host)",
        "fingerprint": "指纹",
        "defaultOption": "默认",
        "routeMark": "Route Mark",
        "tcpKeepAliveInterval": "TCP Keep Alive 间隔",
        "tcpKeepAliveIdle": "TCP Keep Alive Idle",
        "tcpMaxSeg": "TCP Max Seg",
        "tcpUserTimeout": "TCP User Timeout",
        "tcpWindowClamp": "TCP Window Clamp",
        "tcpFastOpen": "TCP Fast Open",
        "multipathTcp": "Multipath TCP",
        "penetrate": "Penetrate",
        "v6Only": "仅 V6",
        "tcpCongestion": "TCP Congestion",
        "dialerProxy": "Dialer Proxy",
        "trustedXForwardedFor": "可信 X-Forwarded-For",
        "addressPortStrategy": "地址+端口策略",
        "tryDelayMs": "尝试延迟 (ms)",
        "prioritizeIPv6": "IPv6 优先",
        "interleave": "Interleave",
        "maxConcurrentTry": "最大并发尝试",
        "customSockopt": "自定义 sockopt",
        "addCustomOption": "添加自定义选项",
        "serverNameIndication": "SNI",
        "cipherSuites": "Cipher Suites",
        "autoOption": "自动",
        "minMaxVersion": "最小/最大版本",
        "rejectUnknownSni": "拒绝未知 SNI",
        "disableSystemRoot": "禁用系统根",
        "sessionResumption": "会话恢复",
        "oneTimeLoading": "一次性加载",
        "usageOption": "使用选项",
        "buildChain": "构建证书链",
        "echKey": "ECH key",
        "echConfig": "ECH 配置",
        "pinnedPeerCertSha256": "固定对端证书 SHA-256",
        "pinnedPeerCertSha256Tip": "对端证书的 Base64 编码 SHA-256 哈希。仅面板使用 — 不写入服务器的 xray 配置，但会包含在分享链接中，以便客户端固定证书。",
        "pinnedPeerCertSha256Placeholder": "base64 哈希，逗号分隔",
        "generateRandomPin": "生成随机哈希",
        "getNewEchCert": "获取新 ECH 证书",
        "show": "显示",
        "xver": "Xver",
        "target": "目标",
        "maxTimeDiff": "最大时间差 (ms)",
        "minClientVer": "最小客户端版本",
        "maxClientVer": "最大客户端版本",
        "shortIds": "Short IDs",
        "spiderX": "SpiderX",
        "getNewCert": "获取新证书",
        "mldsa65Seed": "mldsa65 Seed",
        "mldsa65Verify": "mldsa65 Verify",
        "getNewSeed": "获取新 Seed"
      },
      "info": {
        "mode": "模式",
        "grpcServiceName": "grpc serviceName",
        "grpcMultiMode": "grpc multiMode",
        "interfaceName": "接口名称",
        "mtu": "MTU",
        "gateway": "Gateway",
        "dns": "DNS",
        "outboundsInterface": "出站接口",
        "autoSystemRoutes": "自动系统路由",
        "followRedirect": "FollowRedirect",
        "auth": "认证",
        "noKernelTun": "非内核 TUN",
        "keepAlive": "Keep alive",
        "peerNumber": "Peer {n}",
        "peerNumberConfig": "Peer {n} 配置"
      },
      "stream": {
        "general": {
          "request": "请求",
          "response": "响应",
          "name": "名称",
          "value": "值"
        },
        "tcp": {
          "version": "版本",
          "method": "方法",
          "path": "路径",
          "status": "状态",
          "statusDescription": "状态说明",
          "requestHeader": "请求头",
          "responseHeader": "响应头"
        }
      }
    },
    "clients": {
      "add": "添加客户端",
      "edit": "编辑客户端",
      "submitAdd": "添加客户端",
      "submitEdit": "保存更改",
      "clientCount": "客户端数量",
      "bulk": "批量添加",
      "copyFromInbound": "从入站复制客户端",
      "copyToInbound": "复制客户端到",
      "copySelected": "复制所选",
      "copySource": "来源",
      "copyEmailPreview": "生成的邮箱预览",
      "copySelectSourceFirst": "请先选择一个来源入站。",
      "copyResult": "复制结果",
      "copyResultSuccess": "复制成功",
      "copyResultNone": "没有内容可复制：未选中客户端或来源为空",
      "copyResultErrors": "复制错误",
      "copyFlowLabel": "新客户端的 Flow (VLESS)",
      "copyFlowHint": "应用于所有被复制的客户端。留空则跳过。",
      "selectAll": "全选",
      "clearAll": "全部清除",
      "method": "方式",
      "first": "首个",
      "last": "末位",
      "ipLog": "IP 日志",
      "prefix": "前缀",
      "postfix": "后缀",
      "delayedStart": "首次使用后开始",
      "expireDays": "时长",
      "days": "天",
      "renew": "自动续期",
      "renewDesc": "到期后自动续期。(0 = 禁用) (单位: 天)",
      "searchPlaceholder": "搜索邮箱、备注、sub ID、UUID、密码、auth…",
      "filterTitle": "筛选客户端",
      "clearAllFilters": "清除全部",
      "sortOldest": "最旧优先",
      "sortNewest": "最新优先",
      "sortRecentlyUpdated": "最近更新",
      "sortRecentlyOnline": "最近在线",
      "sortEmailAZ": "邮箱 A→Z",
      "sortEmailZA": "邮箱 Z→A",
      "sortMostTraffic": "流量最多",
      "sortHighestRemaining": "剩余最多",
      "sortExpiringSoonest": "即将过期",
      "has": "拥有",
      "hasNot": "不拥有",
      "title": "客户端",
      "actions": "操作",
      "totalGB": "总上传/下载 (GB)",
      "expiryTime": "过期时间",
      "addClients": "添加客户端",
      "limitIp": "IP 限制",
      "password": "密码",
      "subId": "订阅 ID",
      "online": "在线",
      "email": "邮箱",
      "group": "分组",
      "groupDesc": "用于对相关客户端进行分桶的逻辑标签（如团队、客户、地区）。可从工具栏筛选。",
      "groupPlaceholder": "如 customer-a",
      "comment": "备注",
      "traffic": "流量",
      "offline": "离线",
      "addTitle": "添加客户端",
      "qrCode": "二维码",
      "moreInformation": "更多信息",
      "delete": "删除",
      "reset": "重置流量",
      "editTitle": "编辑客户端",
      "client": "客户端",
      "enabled": "已启用",
      "remaining": "剩余",
      "duration": "时长",
      "attachedInbounds": "关联入站",
      "selectInbound": "选择一个或多个入站",
      "noSubId": "该客户端没有 subId，无法生成共享链接。",
      "noLinks": "没有可共享的链接 — 请先将此客户端关联到支持协议的入站。",
      "link": "链接",
      "resetNotPossible": "请先将此客户端关联到入站。",
      "general": "常规",
      "resetAllTraffics": "重置所有客户端流量",
      "resetAllTrafficsTitle": "重置所有客户端流量？",
      "resetAllTrafficsContent": "所有客户端的上下行计数器将归零。配额与过期时间不受影响。该操作不可撤销。",
      "deleteConfirmTitle": "删除客户端 {email}？",
      "deleteConfirmContent": "将从所有关联入站中移除该客户端并删除其流量记录。该操作不可撤销。",
      "deleteSelected": "删除 ({count})",
      "adjustSelected": "调整 ({count})",
      "subLinksSelected": "订阅链接 ({count})",
      "addToGroupTitle": "将 {count} 个客户端添加到分组",
      "addToGroupTooltip": "选择现有分组或输入新名称。使用 Ungroup 操作从当前分组移除客户端。",
      "addToGroupPlaceholder": "分组名称",
      "addToGroupSuccessToast": "已将 {count} 个客户端添加到 {group}",
      "ungroupSuccessToast": "已清除 {count} 个客户端的分组",
      "ungroup": "取消分组",
      "ungroupConfirmTitle": "将 {count} 个客户端从其分组中移除?",
      "ungroupConfirmContent": "清除每个选中客户端的分组标签。客户端本身保留（使用 Delete 完全移除）。",
      "addToGroup": "添加到分组",
      "attach": "附加",
      "adjust": "调整",
      "subLinks": "订阅链接",
      "selectedCount": "已选 {count} 项",
      "attachSelected": "附加 ({count})",
      "attachToInboundsTitle": "将 {count} 个客户端附加到入站",
      "attachToInboundsDesc": "将选中的 {count} 个客户端（相同 UUID/密码和共享流量）附加到选定的入站。它们保留现有的附加关系。",
      "attachToInboundsTargets": "目标入站",
      "attachToInboundsNoTargets": "没有可用于附加的多用户入站。",
      "detachSelected": "分离 ({count})",
      "detach": "分离",
      "detachFromInboundsTitle": "从入站分离 {count} 个客户端",
      "detachFromInboundsDesc": "从选定的入站中移除选中的 {count} 个客户端。客户端未附加的配对将被静默跳过。客户端记录保留（使用 Delete 完全移除）。",
      "detachFromInboundsTargets": "要分离的入站",
      "detachFromInboundsNoTargets": "没有可用的多用户入站。",
      "detachFromInboundsResult": "已分离 {detached},已跳过 {skipped}。",
      "detachFromInboundsResultMixed": "已分离 {detached},已跳过 {skipped},错误 {errors}。",
      "subLinksTitle": "订阅链接 ({count})",
      "subLinkColumn": "订阅 URL",
      "subJsonLinkColumn": "订阅 JSON URL",
      "subLinksCopyAll": "全部复制",
      "subLinksCopiedAll": "已复制 {count} 条链接",
      "subLinksEmpty": "选中的客户端均无订阅 ID。",
      "subLinksDisabled": "订阅服务已禁用。",
      "subLinksDisabledHint": "在面板设置 → 订阅中启用订阅以生成链接。",
      "bulkDeleteConfirmTitle": "删除 {count} 个客户端？",
      "bulkDeleteConfirmContent": "每个所选客户端都会从关联的入站中被移除，其流量记录也会被删除。该操作不可撤销。",
      "bulkAdjustTitle": "调整 {count} 个客户端",
      "bulkAdjustHint": "正值延长，负值减少。具有无限期限或流量的客户端将跳过该字段。",
      "bulkAdjustNothing": "应用前请设置天数或流量。",
      "addDays": "添加天数",
      "addTrafficGB": "添加流量 (GB)",
      "delDepleted": "删除已耗尽",
      "delDepletedConfirmTitle": "删除已耗尽的客户端？",
      "delDepletedConfirmContent": "删除所有流量配额已用尽或已过期的客户端。该操作不可撤销。",
      "auth": "认证",
      "hysteriaAuth": "Hysteria 认证",
      "uuid": "UUID",
      "flow": "Flow",
      "vmessSecurity": "VMess 加密",
      "reverseTag": "反向标签",
      "reverseTagPlaceholder": "可选 Reverse tag",
      "telegramId": "Telegram 用户 ID",
      "telegramIdPlaceholder": "数字形式的 Telegram 用户 ID (0 = 无)",
      "created": "创建时间",
      "updated": "更新时间",
      "ipLimit": "IP 限制",
      "toasts": {
        "deleted": "客户端已删除",
        "trafficReset": "流量已重置",
        "allTrafficsReset": "所有客户端流量已重置",
        "bulkDeleted": "已删除 {count} 个客户端",
        "bulkDeletedMixed": "已删除 {ok} 个，失败 {failed} 个",
        "bulkCreated": "已创建 {count} 个客户端",
        "bulkCreatedMixed": "已创建 {ok} 个，失败 {failed} 个",
        "bulkAdjusted": "已调整 {count} 个客户端",
        "bulkAdjustedMixed": "已调整 {ok} 个，跳过 {skipped} 个",
        "delDepleted": "已删除 {count} 个已耗尽的客户端"
      }
    },
    "groups": {
      "title": "分组",
      "name": "名称",
      "clientCount": "分组中的客户端",
      "totalGroups": "分组总数",
      "totalGroupedClients": "有分组的客户端",
      "emptyGroups": "空分组",
      "addGroup": "添加分组",
      "createSuccess": "已创建分组 “{name}”。",
      "rename": "重命名",
      "renameTitle": "重命名 {name}",
      "renameCollision": "已存在名为 “{name}” 的分组。",
      "renameSuccess": "已为 {count} 个客户端重命名分组。",
      "deleteConfirmTitle": "删除分组 {name}?",
      "deleteConfirmContent": "这将删除分组并清除 {count} 个客户端的标签。客户端本身不会被删除。",
      "deleteSuccess": "已清除 {count} 个客户端的分组。",
      "resetTraffic": "重置流量",
      "resetConfirmTitle": "重置分组 {name} 的流量?",
      "resetConfirmContent": "这将清零此分组中所有 {count} 个客户端的上行/下行流量。",
      "resetSuccess": "已重置 {count} 个客户端的流量。",
      "adjustSuccess": "已调整 {name} 中的 {count} 个客户端。",
      "emptyForAction": "此分组尚无客户端。",
      "deleteGroupOnly": "删除分组(保留客户端)",
      "deleteClients": "删除分组中的客户端",
      "deleteClientsConfirmTitle": "删除 {name} 中的所有客户端?",
      "deleteClientsConfirmContent": "这将永久删除 {count} 个客户端及其流量记录。分组标签也会被清除。此操作无法撤销。",
      "deleteClientsSuccess": "已删除 {count} 个客户端。",
      "deleteClientsMixed": "已删除 {ok},已跳过 {failed}",
      "addToGroup": "添加客户端…",
      "addToGroupTitle": "添加客户端到分组 “{name}”",
      "addToGroupDesc": "选择要添加到此分组的客户端。保留其现有入站附加;仅更改分组标签。已在此分组中的客户端不会列出。",
      "addToGroupEmpty": "没有其他可添加的客户端。",
      "addToGroupResult": "已将 {count} 个客户端添加到 {name}。",
      "removeFromGroup": "移除客户端…",
      "removeFromGroupTitle": "从分组 “{name}” 移除客户端",
      "removeFromGroupDesc": "选择要从此分组中移除的成员。客户端本身保留(使用 “删除分组中的客户端” 完全移除)。",
      "removeFromGroupResult": "已从 {name} 移除 {count} 个客户端。"
    },
    "nodes": {
      "title": "节点",
      "addNode": "添加节点",
      "editNode": "编辑节点",
      "totalNodes": "节点总数",
      "onlineNodes": "在线",
      "offlineNodes": "离线",
      "avgLatency": "平均延迟",
      "name": "名称",
      "namePlaceholder": "例如：de-frankfurt-1",
      "addressPlaceholder": "panel.example.com 或 1.2.3.4",
      "remark": "备注",
      "scheme": "协议",
      "address": "地址",
      "port": "端口",
      "basePath": "Base Path",
      "apiToken": "API Token",
      "apiTokenPlaceholder": "远程面板设置页中的令牌",
      "apiTokenHint": "远程面板在 设置 → API 令牌 中显示其 API 令牌。",
      "regenerate": "重新生成令牌",
      "regenerateConfirm": "重新生成会使当前令牌失效。任何使用该令牌的中央面板都会失去访问权限，直至更新。是否继续？",
      "allowPrivateAddress": "允许私有地址",
      "allowPrivateAddressHint": "仅对私有网络或VPN上的节点启用。",
      "enable": "已启用",
      "status": "状态",
      "cpu": "CPU",
      "mem": "内存",
      "uptime": "运行时长",
      "latency": "延迟",
      "lastHeartbeat": "上次心跳",
      "xrayVersion": "Xray 版本",
      "panelVersion": "面板版本",
      "actions": "操作",
      "probe": "立即探测",
      "testConnection": "测试连接",
      "connectionOk": "连接正常 ({ms} ms)",
      "connectionFailed": "连接失败",
      "never": "从未",
      "justNow": "刚刚",
      "deleteConfirmTitle": "删除节点 \"{name}\"？",
      "deleteConfirmContent": "这将停止监控该节点。远程面板本身不受影响。",
      "statusValues": {
        "online": "在线",
        "offline": "离线",
        "unknown": "未知"
      },
      "toasts": {
        "list": "加载节点失败",
        "obtain": "加载节点失败",
        "add": "添加节点",
        "update": "更新节点",
        "delete": "删除节点",
        "deleted": "节点已删除",
        "test": "测试连接",
        "fillRequired": "名称、地址、端口和 API 令牌为必填项",
        "probeFailed": "探测失败"
      }
    },
    "settings": {
      "title": "面板设置",
      "save": "保存",
      "infoDesc": "此处的所有更改都需要保存并重启面板才能生效",
      "restartPanel": "重启面板",
      "restartPanelDesc": "确定要重启面板吗？若重启后无法访问面板，请前往服务器查看面板日志信息",
      "restartPanelSuccess": "面板已成功重启",
      "actions": "操作",
      "resetDefaultConfig": "重置为默认配置",
      "panelSettings": "常规",
      "securitySettings": "安全设定",
      "securityWarnings": "安全警告",
      "panelExposed": "您的面板可能已暴露：",
      "warnHttp": "面板通过明文 HTTP 提供服务 — 生产环境请配置 TLS。",
      "warnDefaultPort": "默认端口 2053 众所周知 — 请更改为随机端口。",
      "warnDefaultBasePath": "默认根路径 \"/\" 众所周知 — 请更改为随机路径。",
      "warnDefaultSubPath": "默认订阅路径 \"/sub/\" 众所周知 — 请更改。",
      "warnDefaultJsonPath": "默认 JSON 订阅路径 \"/json/\" 众所周知 — 请更改。",
      "TGBotSettings": "Telegram 机器人",
      "panelListeningIP": "面板监听 IP",
      "panelListeningIPDesc": "默认留空监听所有 IP",
      "panelListeningDomain": "面板监听域名",
      "panelListeningDomainDesc": "默认情况下留空以监视所有域名和 IP 地址",
      "panelPort": "面板监听端口",
      "panelPortDesc": "重启面板生效",
      "publicKeyPath": "面板证书公钥文件路径",
      "publicKeyPathDesc": "填写一个 '/' 开头的绝对路径",
      "privateKeyPath": "面板证书密钥文件路径",
      "privateKeyPathDesc": "填写一个 '/' 开头的绝对路径",
      "panelUrlPath": "URI 路径",
      "panelUrlPathDesc": "必须以 '/' 开头，以 '/' 结尾",
      "pageSize": "分页大小",
      "pageSizeDesc": "定义入站表的页面大小。设置 0 表示禁用",
      "panelProxy": "面板网络代理",
      "panelProxyDesc": "通过此代理路由面板自身的出站请求(geo 更新、Xray/面板版本检查、Telegram),以绕过服务端对 GitHub/Telegram 的过滤。接受 socks5:// 或 http(s)://,如本地 Xray SOCKS 入站。留空表示直连。",
      "remarkModel": "备注模型和分隔符",
      "datepicker": "日期选择器",
      "datepickerPlaceholder": "选择日期",
      "datepickerDescription": "选择器日历类型指定到期日期",
      "sampleRemark": "备注示例",
      "oldUsername": "原用户名",
      "currentPassword": "原密码",
      "newUsername": "新用户名",
      "newPassword": "新密码",
      "telegramBotEnable": "启用 Telegram 机器人",
      "telegramBotEnableDesc": "启用 Telegram 机器人功能",
      "telegramToken": "Telegram Token",
      "telegramTokenDesc": "从 '{'@'}BotFather' 获取的 Telegram 机器人令牌",
      "telegramProxy": "SOCKS 代理",
      "telegramProxyDesc": "启用 SOCKS5 代理连接到 Telegram（根据指南调整设置）",
      "telegramAPIServer": "Telegram API 服务器",
      "telegramAPIServerDesc": "要使用的 Telegram API 服务器。留空以使用默认服务器。",
      "telegramChatId": "管理员聊天 ID",
      "telegramChatIdDesc": "Telegram 管理员聊天 ID (多个以逗号分隔)（可通过 {'@'}userinfobot 获取，或在机器人中使用 '/id' 命令获取）",
      "telegramNotifyTime": "通知时间",
      "telegramNotifyTimeDesc": "设置周期性的 Telegram 机器人通知时间（使用 crontab 时间格式）",
      "tgNotifyBackup": "数据库备份",
      "tgNotifyBackupDesc": "发送带有报告的数据库备份文件",
      "tgNotifyLogin": "登录通知",
      "tgNotifyLoginDesc": "当有人试图登录你的面板时显示用户名、IP 地址和时间",
      "sessionMaxAge": "会话时长",
      "sessionMaxAgeDesc": "保持登录状态的时长（单位：分钟）",
      "expireTimeDiff": "到期通知阈值",
      "expireTimeDiffDesc": "达到此阈值时，将收到有关到期时间的通知（单位：天）",
      "trafficDiff": "流量耗尽阈值",
      "trafficDiffDesc": "达到此阈值时，将收到有关流量耗尽的通知（单位：GB）",
      "tgNotifyCpu": "CPU 负载通知阈值",
      "tgNotifyCpuDesc": "CPU 负载超过此阈值时，将收到通知（单位：%）",
      "timeZone": "时区",
      "timeZoneDesc": "定时任务将按照该时区的时间运行",
      "subSettings": "订阅设置",
      "subEnable": "启用订阅服务",
      "subEnableDesc": "启用订阅服务功能",
      "subJsonEnable": "单独启用/禁用 JSON 订阅端点。",
      "subJsonEnableTitle": "JSON 订阅",
      "subClashEnableTitle": "Clash / Mihomo 订阅",
      "subTitle": "订阅标题",
      "subTitleDesc": "在VPN客户端中显示的标题",
      "subSupportUrl": "支持链接",
      "subSupportUrlDesc": "VPN 客户端中显示的技术支持链接",
      "subProfileUrl": "个人资料链接",
      "subProfileUrlDesc": "VPN 客户端中显示的网站链接",
      "subAnnounce": "公告",
      "subAnnounceDesc": "VPN 客户端中显示的公告文本",
      "subEnableRouting": "启用路由",
      "subEnableRoutingDesc": "在 VPN 客户端中启用路由的全局设置。（僅限 Happ）",
      "subRoutingRules": "路由規則",
      "subRoutingRulesDesc": "VPN 用戶端的全域路由規則。（僅限 Happ）",
      "subListen": "监听 IP",
      "subListenDesc": "订阅服务监听的 IP 地址（留空表示监听所有 IP）",
      "subPort": "监听端口",
      "subPortDesc": "订阅服务监听的端口号（必须是未使用的端口）",
      "subCertPath": "公钥路径",
      "subCertPathDesc": "订阅服务使用的公钥文件路径（以 '/' 开头）",
      "subKeyPath": "私钥路径",
      "subKeyPathDesc": "订阅服务使用的私钥文件路径（以 '/' 开头）",
      "subPath": "URI 路径",
      "subPathDesc": "订阅服务使用的 URI 路径（以 '/' 开头，以 '/' 结尾）",
      "subDomain": "监听域名",
      "subDomainDesc": "订阅服务监听的域名（留空表示监听所有域名和 IP）",
      "subUpdates": "更新间隔",
      "subUpdatesDesc": "客户端应用中订阅 URL 的更新间隔（单位：小时）",
      "subEncrypt": "编码",
      "subEncryptDesc": "订阅服务返回的内容将采用 Base64 编码",
      "subShowInfo": "显示使用信息",
      "subShowInfoDesc": "客户端应用中将显示剩余流量和日期信息",
      "subEmailInRemark": "在名称中包含邮箱",
      "subEmailInRemarkDesc": "在订阅配置名称中包含客户端邮箱。",
      "subURI": "反向代理 URI",
      "subURIDesc": "用于代理后面的订阅 URL 的 URI 路径",
      "externalTrafficInformEnable": "外部交通通知",
      "externalTrafficInformEnableDesc": "每次流量更新时通知外部 API。",
      "externalTrafficInformURI": "外部流量通知 URI",
      "externalTrafficInformURIDesc": "流量更新将发送到此 URI",
      "restartXrayOnClientDisable": "客户端自动禁用后重启 Xray",
      "restartXrayOnClientDisableDesc": "当客户端因到期或流量超限被自动禁用时，重启 Xray。",
      "fragment": "分片",
      "fragmentDesc": "启用 TLS hello 数据包分片",
      "fragmentSett": "设置",
      "noisesDesc": "启用 Noises.",
      "noisesSett": "Noises 设置",
      "trustedProxyCidrs": "可信代理 CIDR",
      "trustedProxyCidrsDesc": "允许设置转发 host、proto 和客户端 IP 标头的 IP/CIDR(逗号分隔)。",
      "ldap": {
        "enable": "启用 LDAP 同步",
        "host": "LDAP host",
        "port": "LDAP 端口",
        "useTls": "使用 TLS (LDAPS)",
        "bindDn": "Bind DN",
        "passwordConfigured": "已配置;留空以保留当前密码。",
        "passwordUnconfigured": "未配置。",
        "passwordPlaceholder": "已配置 - 输入新值以替换",
        "baseDn": "Base DN",
        "userFilter": "用户筛选",
        "userAttr": "用户属性 (username/email)",
        "vlessField": "VLESS flag 属性",
        "flagField": "通用 flag 属性 (可选)",
        "flagFieldDesc": "如设置,将覆盖 VLESS flag — 如 shadowInactive。",
        "truthyValues": "Truthy 值",
        "truthyValuesDesc": "逗号分隔;默认: true,1,yes,on",
        "invertFlag": "反转 flag",
        "invertFlagDesc": "当属性表示已禁用时启用 (如 shadowInactive)。",
        "syncSchedule": "同步计划",
        "syncScheduleDesc": "类 cron 字符串,如 @every 1m",
        "inboundTags": "入站标签",
        "inboundTagsDesc": "允许 LDAP 同步自动创建或删除客户端的入站。",
        "noInbounds": "未找到入站。请先在“入站”中创建。",
        "autoCreate": "自动创建客户端",
        "autoDelete": "自动删除客户端",
        "defaultTotalGb": "默认总流量 (GB)",
        "defaultExpiryDays": "默认到期 (天)",
        "defaultIpLimit": "默认 IP 限制"
      },
      "subFormats": {
        "packets": "数据包",
        "length": "长度",
        "interval": "间隔",
        "maxSplit": "最大分割",
        "noises": "噪声",
        "noiseItem": "噪声 №{n}",
        "type": "类型",
        "packet": "数据包",
        "delayMs": "延迟 (ms)",
        "applyTo": "应用于",
        "addNoise": "+ 噪声",
        "concurrency": "并发",
        "xudpConcurrency": "xudp 并发",
        "xudpUdp443": "xudp UDP 443"
      },
      "mux": "Mux",
      "muxDesc": "在已建立的数据流内传输多个独立的数据流",
      "muxSett": "复用器设置",
      "direct": "直接连接",
      "directDesc": "直接与特定国家的域或IP范围建立连接",
      "notifications": "通知",
      "certs": "证书",
      "externalTraffic": "外部流量",
      "dateAndTime": "日期和时间",
      "proxyAndServer": "代理和服务器",
      "intervals": "间隔",
      "information": "信息",
      "language": "语言",
      "telegramBotLanguage": "Telegram 机器人语言",
      "security": {
        "admin": "管理员凭据",
        "twoFactor": "双重验证",
        "twoFactorEnable": "启用2FA",
        "twoFactorEnableDesc": "增加额外的验证层以提高安全性。",
        "twoFactorModalSetTitle": "启用双重认证",
        "twoFactorModalDeleteTitle": "停用双重认证",
        "twoFactorModalSteps": "要设定双重认证，请执行以下步骤：",
        "twoFactorModalFirstStep": "1. 在认证应用程序中扫描此QR码，或复制QR码附近的令牌并粘贴到应用程序中",
        "twoFactorModalSecondStep": "2. 输入应用程序中的验证码",
        "twoFactorModalRemoveStep": "输入应用程序中的验证码以移除双重认证。",
        "twoFactorModalChangeCredentialsTitle": "更改凭据",
        "twoFactorModalChangeCredentialsStep": "输入应用程序中的代码以更改管理员凭据。",
        "twoFactorModalSetSuccess": "双因素认证已成功建立",
        "twoFactorModalDeleteSuccess": "双因素认证已成功删除",
        "twoFactorModalError": "验证码错误",
        "show": "显示",
        "hide": "隐藏",
        "apiTokenNew": "新建令牌",
        "apiTokenName": "名称",
        "apiTokenNamePlaceholder": "例如 central-panel-a",
        "apiTokenNameRequired": "名称必填",
        "apiTokenEmpty": "暂无令牌 — 创建一个用于认证机器人或远程面板。",
        "apiTokenDeleteWarning": "使用此令牌的任何调用方将立即无法认证。"
      },
      "toasts": {
        "modifySettings": "参数已更改。",
        "getSettings": "获取参数时发生错误",
        "modifyUserError": "更改管理员凭据时发生错误。",
        "modifyUser": "您已成功更改管理员凭据。",
        "originalUserPassIncorrect": "原用户名或原密码错误",
        "userPassMustBeNotEmpty": "新用户名和新密码不能为空",
        "getOutboundTrafficError": "获取出站流量错误",
        "resetOutboundTrafficError": "重置出站流量错误"
      }
    },
    "xray": {
      "title": "Xray 配置",
      "save": "保存",
      "restart": "重启 Xray",
      "restartSuccess": "Xray 已成功重新启动",
      "restartOutputTitle": "Xray 重启输出",
      "restartConfirmTitle": "重启 xray?",
      "restartConfirmContent": "使用已保存的配置重新加载 xray 服务。",
      "stopSuccess": "Xray 已成功停止",
      "restartError": "重启Xray时发生错误。",
      "stopError": "停止Xray时发生错误。",
      "basicTemplate": "基础配置",
      "advancedTemplate": "高级配置",
      "generalConfigs": "常规配置",
      "generalConfigsDesc": "这些选项将决定常规配置",
      "logConfigs": "日志",
      "logConfigsDesc": "日志可能会影响服务器的性能，建议仅在需要时启用",
      "blockConfigsDesc": "这些选项将阻止用户连接到特定协议和网站",
      "basicRouting": "基本路由",
      "blockConnectionsConfigsDesc": "这些选项将根据特定的请求国家阻止流量。",
      "directConnectionsConfigsDesc": "直接连接确保特定的流量不会通过其他服务器路由。",
      "blockips": "阻止IP",
      "blockdomains": "阻止域名",
      "directips": "直接IP",
      "directdomains": "直接域名",
      "ipv4Routing": "IPv4 路由",
      "ipv4RoutingDesc": "此选项将仅通过 IPv4 路由到目标域",
      "warpRouting": "WARP 路由",
      "warpRoutingDesc": "注意：在使用这些选项之前，请按照面板 GitHub 上的步骤在你的服务器上以 socks5 代理模式安装 WARP。WARP 将通过 Cloudflare 服务器将流量路由到网站。",
      "nordRouting": "NordVPN 路由",
      "nordRoutingDesc": "这些选项将根据特定目的地通过 NordVPN 路由流量。",
      "Template": "高级 Xray 配置模板",
      "TemplateDesc": "最终的 Xray 配置文件将基于此模板生成",
      "FreedomStrategy": "Freedom 协议策略",
      "FreedomStrategyDesc": "设置 Freedom 协议中网络的输出策略",
      "RoutingStrategy": "配置路由域策略",
      "RoutingStrategyDesc": "设置 DNS 解析的整体路由策略",
      "outboundTestUrl": "出站测试 URL",
      "outboundTestUrlDesc": "测试出站连接时使用的 URL",
      "Torrent": "屏蔽 BitTorrent 协议",
      "Inbounds": "入站",
      "InboundsDesc": "接受来自特定客户端的流量",
      "Outbounds": "出站",
      "Balancers": "负载均衡",
      "balancerTagRequired": "标签为必填项",
      "balancerSelectorRequired": "至少选择一个出站",
      "OutboundsDesc": "设置出站流量传出方式",
      "Routings": "路由规则",
      "RoutingsDesc": "每条规则的优先级都很重要",
      "completeTemplate": "全部",
      "logLevel": "日志级别",
      "logLevelDesc": "错误日志的日志级别，用于指示需要记录的信息",
      "accessLog": "访问日志",
      "accessLogDesc": "访问日志的文件路径。特殊值 'none' 禁用访问日志",
      "errorLog": "错误日志",
      "errorLogDesc": "错误日志的文件路径。特殊值 'none' 禁用错误日志",
      "dnsLog": "DNS 日志",
      "dnsLogDesc": "是否启用 DNS 查询日志",
      "maskAddress": "隐藏地址",
      "maskAddressDesc": "IP 地址掩码，启用时会自动替换日志中出现的 IP 地址。",
      "statistics": "统计",
      "statsInboundUplink": "入站上传统计",
      "statsInboundUplinkDesc": "启用所有入站代理的上行流量统计收集。",
      "statsInboundDownlink": "入站下载统计",
      "statsInboundDownlinkDesc": "启用所有入站代理的下行流量统计收集。",
      "statsOutboundUplink": "出站上传统计",
      "statsOutboundUplinkDesc": "启用所有出站代理的上行流量统计收集。",
      "statsOutboundDownlink": "出站下载统计",
      "statsOutboundDownlinkDesc": "启用所有出站代理的下行流量统计收集。",
      "rules": {
        "first": "置顶",
        "last": "置底",
        "up": "向上",
        "down": "向下",
        "source": "来源",
        "dest": "目的地址",
        "inbound": "入站",
        "outbound": "出站",
        "balancer": "负载均衡",
        "info": "信息",
        "add": "添加规则",
        "edit": "编辑规则",
        "useComma": "逗号分隔的项目"
      },
      "routing": {
        "dragToReorder": "拖动以重新排序"
      },
      "ruleForm": {
        "sourceIps": "源 IP",
        "sourcePort": "源端口",
        "vlessRoute": "VLESS 路由",
        "attributes": "属性",
        "value": "值",
        "user": "用户",
        "inboundTags": "入站标签",
        "outboundTag": "出站标签",
        "balancerTag": "均衡器标签",
        "balancerTagTooltip": "通过其中一个已配置的负载均衡器路由流量"
      },
      "outboundForm": {
        "tagDuplicate": "该标签已被其他出站使用",
        "tagRequired": "标签为必填项",
        "tagPlaceholder": "唯一标签",
        "localIpPlaceholder": "本地 IP",
        "addressRequired": "地址为必填项",
        "portRequired": "端口为必填项",
        "optional": "可选",
        "udpOverTcp": "UDP over TCP",
        "uotVersion": "UoT 版本",
        "inboundTag": "入站标签",
        "inboundTagPlaceholder": "用于路由规则的入站标签",
        "responseType": "响应类型",
        "rewriteNetwork": "重写网络",
        "unchanged": "(未更改)",
        "unchangedAddress": "(未更改) 如 1.1.1.1",
        "rules": "规则",
        "ruleN": "规则 {n}",
        "action": "操作",
        "redirect": "Redirect",
        "fragment": "Fragment",
        "finalRules": "最终规则",
        "overrideXrayPrivateIp": "覆盖 Xray 默认的私有 IP 阻止",
        "blockDelay": "阻塞延迟 (ms)",
        "reverseSniffing": "反向 sniffing",
        "workers": "Workers",
        "reserved": "保留",
        "minUploadInterval": "最小上传间隔 (ms)",
        "maxUploadSizeBytes": "最大上传大小 (字节)",
        "uplinkChunkSize": "Uplink chunk 大小",
        "noGrpcHeader": "无 gRPC 头",
        "maxConcurrency": "最大并发",
        "maxConnections": "最大连接",
        "maxReuseTimes": "最大复用次数",
        "maxRequestTimes": "最大请求次数",
        "maxReusableSecs": "最大可复用秒数",
        "keepAlivePeriod": "keep alive 周期",
        "authPassword": "认证密码",
        "visionTestpre": "Vision testpre",
        "serverNamePlaceholder": "服务器名",
        "verifyPeerName": "验证 peer 名称",
        "pinnedSha256": "Pinned SHA256",
        "shortId": "Short ID",
        "sockopts": "Sockopts",
        "keepAliveInterval": "keep alive 间隔",
        "markFwmark": "Mark (fwmark)",
        "interface": "接口",
        "ipv6Only": "仅 IPv6",
        "acceptProxyProtocol": "接受 proxy protocol",
        "tcpUserTimeoutMs": "TCP user timeout (ms)",
        "tcpKeepAliveIdleS": "TCP keep-alive idle (s)"
      },
      "outbound": {
        "addOutbound": "添加出站",
        "addReverse": "添加反向",
        "editOutbound": "编辑出站",
        "editReverse": "编辑反向",
        "reverseTag": "反向标签",
        "reverseTagDesc": "VLESS 简易反向代理出站标签。留空则禁用。设置后，此客户端的连接可用作反向代理隧道。",
        "reverseTagPlaceholder": "出站标签（留空则禁用）",
        "tag": "标签",
        "tagDesc": "唯一标签",
        "address": "地址",
        "reverse": "反向",
        "domain": "域名",
        "type": "类型",
        "bridge": "Bridge",
        "portal": "Portal",
        "link": "链接",
        "intercon": "互连",
        "settings": "设置",
        "accountInfo": "帐户信息",
        "outboundStatus": "出站状态",
        "sendThrough": "发送通过",
        "test": "测试",
        "testResult": "测试结果",
        "testing": "正在测试连接...",
        "testSuccess": "测试成功",
        "testFailed": "测试失败",
        "testError": "测试出站失败",
        "testModeTooltip": "TCP: 快速 dial-only 探测。HTTP: 通过 xray 的完整请求。",
        "testAll": "全部测试",
        "nordvpn": "NordVPN",
        "accessToken": "访问令牌",
        "country": "国家",
        "server": "服务器",
        "city": "城市",
        "allCities": "所有城市",
        "privateKey": "私钥",
        "load": "负载"
      },
      "balancer": {
        "addBalancer": "添加负载均衡",
        "editBalancer": "编辑负载均衡",
        "balancerStrategy": "策略",
        "balancerSelectors": "选择器",
        "tag": "标签",
        "tagDesc": "唯一标签",
        "tagDuplicate": "该标签已被其他均衡器使用",
        "tagPlaceholder": "唯一均衡器标签",
        "selector": "选择器",
        "fallback": "Fallback",
        "expected": "期望",
        "expectedPlaceholder": "最佳节点数",
        "maxRtt": "最大 RTT",
        "tolerance": "容差",
        "baselines": "Baselines",
        "costs": "Costs",
        "balancerDesc": "无法同时使用 balancerTag 和 outboundTag。如果同时使用，则只有 outboundTag 会生效。"
      },
      "wireguard": {
        "secretKey": "密钥",
        "publicKey": "公钥",
        "allowedIPs": "允许的 IP",
        "endpoint": "端点",
        "psk": "共享密钥",
        "domainStrategy": "域策略"
      },
      "tun": {
        "nameDesc": "TUN 接口的名称。默认值为 'xray0'",
        "mtuDesc": "最大传输单元。数据包的最大大小。默认值为 1500",
        "userLevel": "用户级别",
        "userLevelDesc": "通过此入站的所有连接都将使用此用户级别。默认值为 0"
      },
      "nord": {
        "accessToken": "Access token",
        "privateKey": "私钥",
        "noServers": "未找到选定国家/地区的服务器",
        "noPublicKey": "选定的服务器未公布 NordLynx 公钥。",
        "outboundAdded": "NordVPN 出站已添加",
        "outboundUpdated": "NordVPN 出站已更新"
      },
      "warp": {
        "licenseError": "设置 WARP 许可证失败。",
        "fetchFirst": "请先获取 WARP 配置。",
        "createAccount": "创建 WARP 账户",
        "accessToken": "Access token",
        "deviceId": "设备 ID",
        "licenseKey": "许可证密钥",
        "privateKey": "私钥",
        "deleteAccount": "删除账户",
        "settings": "设置",
        "licenseKeyLabel": "WARP / WARP+ 许可证密钥",
        "key": "密钥",
        "keyPlaceholder": "26 位 WARP+ 密钥",
        "accountInfo": "账户信息",
        "deviceName": "设备名称",
        "deviceModel": "设备型号",
        "deviceEnabled": "设备已启用",
        "accountType": "账户类型",
        "role": "角色",
        "warpPlusData": "WARP+ 数据",
        "quota": "配额",
        "usage": "使用",
        "addOutbound": "添加出站"
      },
      "dns": {
        "enable": "启用 DNS",
        "enableDesc": "启用内置 DNS 服务器",
        "tag": "DNS 入站标签",
        "tagDesc": "此标签将在路由规则中可用作入站标签",
        "clientIp": "客户端IP",
        "clientIpDesc": "用于在DNS查询期间通知服务器指定的IP位置",
        "disableCache": "禁用缓存",
        "disableCacheDesc": "禁用DNS缓存",
        "disableFallback": "禁用回退",
        "disableFallbackDesc": "禁用回退DNS查询",
        "disableFallbackIfMatch": "匹配时禁用回退",
        "disableFallbackIfMatchDesc": "当DNS服务器的匹配域名列表命中时，禁用回退DNS查询",
        "enableParallelQuery": "启用并行查询",
        "enableParallelQueryDesc": "启用并行DNS查询到多个服务器以实现更快的解析",
        "strategy": "查询策略",
        "strategyDesc": "解析域名的总体策略",
        "add": "添加服务器",
        "edit": "编辑服务器",
        "domains": "域名",
        "expectIPs": "预期 IP",
        "unexpectIPs": "意外IP",
        "useSystemHosts": "使用系统Hosts",
        "useSystemHostsDesc": "使用已安装系统的hosts文件",
        "serveStale": "提供过期结果",
        "serveStaleDesc": "在后台刷新时返回过期的缓存结果",
        "serveExpiredTTL": "过期TTL",
        "serveExpiredTTLDesc": "过期缓存条目的有效期（秒）；0 = 永不过期",
        "timeoutMs": "超时 (毫秒)",
        "skipFallback": "跳过回退",
        "finalQuery": "最终查询",
        "hosts": "Hosts",
        "hostsAdd": "添加 Host",
        "hostsEmpty": "未定义任何 Host",
        "hostsDomain": "域名 (例如 domain:example.com)",
        "hostsValues": "IP 或域名 — 输入后按 Enter",
        "usePreset": "使用模板",
        "dnsPresetTitle": "DNS模板",
        "dnsPresetFamily": "家庭",
        "clearAll": "删除全部",
        "clearAllTitle": "删除所有 DNS 服务器？",
        "clearAllConfirm": "此操作将从列表中删除所有 DNS 服务器，且无法撤销。"
      },
      "fakedns": {
        "add": "添加假 DNS",
        "edit": "编辑假 DNS",
        "ipPool": "IP 池子网",
        "poolSize": "池大小"
      }
    }
  },
  "tgbot": {
    "keyboardClosed": "❌ 自定义键盘已关闭！",
    "noResult": "❗ 没有结果！",
    "noQuery": "❌ 未找到查询！请再次使用该命令！",
    "wentWrong": "❌ 出了点问题！",
    "noIpRecord": "❗ 没有IP记录！",
    "noInbounds": "❗ 未找到入站！",
    "unlimited": "♾ 无限（重置）",
    "add": "添加",
    "month": "月",
    "months": "月",
    "day": "天",
    "days": "天",
    "hours": "小时",
    "minutes": "分钟",
    "unknown": "未知",
    "inbounds": "入站",
    "clients": "客户端",
    "offline": "🔴 离线",
    "online": "🟢 在线",
    "commands": {
      "unknown": "❗ 未知命令",
      "pleaseChoose": "👇 请选择：\r\n",
      "help": "🤖 欢迎使用本机器人！它旨在为您提供来自服务器的特定数据，并允许您进行必要的修改。\r\n\r\n",
      "start": "👋 你好，<i>{{ .Firstname }}</i>。\r\n",
      "welcome": "🤖 欢迎来到 <b>{{ .Hostname }}</b> 管理机器人。\r\n",
      "status": "✅ 机器人正常运行！",
      "usage": "❗ 请输入要搜索的文本！",
      "getID": "🆔 您的 ID 为：<code>{{ .ID }}</code>",
      "helpAdminCommands": "要重新启动 Xray Core：\r\n<code>/restart</code>\r\n\r\n要搜索客户电子邮件：\r\n<code>/usage [电子邮件]</code>\r\n\r\n要搜索入站（带有客户统计数据）：\r\n<code>/inbound [备注]</code>\r\n\r\nTelegram聊天ID：\r\n<code>/id</code>",
      "helpClientCommands": "要搜索统计数据，请使用以下命令：\r\n<code>/usage [电子邮件]</code>\r\n\r\nTelegram聊天ID：\r\n<code>/id</code>",
      "restartUsage": "\r\n\r\n<code>/restart</code>",
      "restartSuccess": "✅ 操作成功!",
      "restartFailed": "❗ 操作错误。\r\n\r\n<code>错误: {{ .Error }}</code>.",
      "xrayNotRunning": "❗ Xray Core 未运行。",
      "startDesc": "显示主菜单",
      "helpDesc": "机器人帮助",
      "statusDesc": "检查机器人状态",
      "idDesc": "显示您的 Telegram ID"
    },
    "messages": {
      "cpuThreshold": "🔴 CPU 使用率为 {{ .Percent }}%，超过阈值 {{ .Threshold }}%",
      "selectUserFailed": "❌ 用户选择错误！",
      "userSaved": "✅ 电报用户已保存。",
      "loginSuccess": "✅ 成功登录到面板。\r\n",
      "loginFailed": "❗️ 面板登录失败。\r\n",
      "2faFailed": "2FA 失败",
      "report": "🕰 定时报告：{{ .RunTime }}\r\n",
      "datetime": "⏰ 日期时间：{{ .DateTime }}\r\n",
      "hostname": "💻 主机: {{ .Hostname }}\r\n",
      "version": "🚀 X-UI 版本：{{ .Version }}\r\n",
      "xrayVersion": "📡 Xray 版本: {{ .XrayVersion }}\r\n",
      "ipv6": "🌐 IPv6: {{ .IPv6 }}\r\n",
      "ipv4": "🌐 IPv4: {{ .IPv4 }}\r\n",
      "ip": "🌐 IP: {{ .IP }}\r\n",
      "ips": "🔢 IPs:\r\n{{ .IPs }}\r\n",
      "serverUpTime": "⏳ 服务器运行时间：{{ .UpTime }} {{ .Unit }}\r\n",
      "serverLoad": "📈 服务器负载：{{ .Load1 }}, {{ .Load2 }}, {{ .Load3 }}\r\n",
      "serverMemory": "📋 RAM: {{ .Current }}/{{ .Total }}\r\n",
      "tcpCount": "🔹 TCP: {{ .Count }}\r\n",
      "udpCount": "🔸 UDP: {{ .Count }}\r\n",
      "traffic": "🚦 流量：{{ .Total }} (↑{{ .Upload }},↓{{ .Download }})\r\n",
      "xrayStatus": "ℹ️ 状态: {{ .State }}\r\n",
      "username": "👤 用户名：{{ .Username }}\r\n",
      "reason": "❗️ 原因：{{ .Reason }}\r\n",
      "time": "⏰ 时间：{{ .Time }}\r\n",
      "inbound": "📍 入站: {{ .Remark }}\r\n",
      "port": "🔌 端口: {{ .Port }}\r\n",
      "expire": "📅 过期日期：{{ .Time }}\r\n",
      "expireIn": "📅 剩余时间：{{ .Time }}\r\n",
      "active": "💡 激活：{{ .Enable }}\r\n",
      "enabled": "🚨 已启用：{{ .Enable }}\r\n",
      "online": "🌐 连接状态：{{ .Status }}\r\n",
      "lastOnline": "🔙 上次在线: {{ .Time }}\r\n",
      "email": "📧 邮箱: {{ .Email }}\r\n",
      "upload": "🔼 上传: ↑{{ .Upload }}\r\n",
      "download": "🔽 下载: ↓{{ .Download }}\r\n",
      "total": "📊 总计: ↑↓{{ .UpDown }} / {{ .Total }}\r\n",
      "TGUser": "👤 电报用户：{{ .TelegramID }}\r\n",
      "exhaustedMsg": "🚨 耗尽的 {{ .Type }}：\r\n",
      "exhaustedCount": "🚨 耗尽的 {{ .Type }} 数量：\r\n",
      "onlinesCount": "🌐 在线客户：{{ .Count }}\r\n",
      "disabled": "🛑 禁用：{{ .Disabled }}\r\n",
      "depleteSoon": "🔜 即将耗尽：{{ .Deplete }}\r\n\r\n",
      "backupTime": "🗄 备份时间：{{ .Time }}\r\n",
      "refreshedOn": "\r\n📋🔄 刷新时间：{{ .Time }}\r\n\r\n",
      "yes": "✅ 是的",
      "no": "❌ 否",
      "received_id": "🔑📥 ID 已更新。",
      "received_password": "🔑📥 密码已更新。",
      "received_email": "📧📥 邮箱已更新。",
      "received_comment": "💬📥 评论已更新。",
      "id_prompt": "🔑 默认 ID: {{ .ClientId }}\n\n请输入您的 ID。",
      "pass_prompt": "🔑 默认密码: {{ .ClientPassword }}\n\n请输入您的密码。",
      "email_prompt": "📧 默认邮箱: {{ .ClientEmail }}\n\n请输入您的邮箱。",
      "comment_prompt": "💬 默认评论: {{ .ClientComment }}\n\n请输入您的评论。",
      "inbound_client_data_id": "🔄 入站: {{ .InboundRemark }}\n\n🔑 ID: {{ .ClientId }}\n📧 邮箱: {{ .ClientEmail }}\n📊 流量: {{ .ClientTraffic }}\n📅 到期日期: {{ .ClientExp }}\n🌐 IP 限制: {{ .IpLimit }}\n💬 备注: {{ .ClientComment }}\n\n你现在可以将客户添加到入站了！",
      "inbound_client_data_pass": "🔄 入站: {{ .InboundRemark }}\n\n🔑 密码: {{ .ClientPass }}\n📧 邮箱: {{ .ClientEmail }}\n📊 流量: {{ .ClientTraffic }}\n📅 到期日期: {{ .ClientExp }}\n🌐 IP 限制: {{ .IpLimit }}\n💬 备注: {{ .ClientComment }}\n\n你现在可以将客户添加到入站了！",
      "cancel": "❌ 进程已取消！\n\n您可以随时使用 /start 重新开始。 🔄",
      "error_add_client": "⚠️ 错误:\n\n {{ .error }}",
      "using_default_value": "好的，我会使用默认值。 😊",
      "incorrect_input": "您的输入无效。\n短语应连续输入，不能有空格。\n正确示例: aaaaaa\n错误示例: aaa aaa 🚫",
      "AreYouSure": "你确定吗？🤔",
      "SuccessResetTraffic": "📧 邮箱: {{ .ClientEmail }}\n🏁 结果: ✅ 成功",
      "FailedResetTraffic": "📧 邮箱: {{ .ClientEmail }}\n🏁 结果: ❌ 失败 \n\n🛠️ 错误: [ {{ .ErrorMessage }} ]",
      "FinishProcess": "🔚 所有客户的流量重置已完成。"
    },
    "buttons": {
      "closeKeyboard": "❌ 关闭键盘",
      "cancel": "❌ 取消",
      "cancelReset": "❌ 取消重置",
      "cancelIpLimit": "❌ 取消 IP 限制",
      "confirmResetTraffic": "✅ 确认重置流量？",
      "confirmClearIps": "✅ 确认清除 IP？",
      "confirmRemoveTGUser": "✅ 确认移除 Telegram 用户？",
      "confirmToggle": "✅ 确认启用/禁用用户？",
      "dbBackup": "获取数据库备份",
      "serverUsage": "服务器使用情况",
      "getInbounds": "获取入站信息",
      "depleteSoon": "即将耗尽",
      "clientUsage": "获取使用情况",
      "onlines": "在线客户端",
      "commands": "命令",
      "refresh": "🔄 刷新",
      "clearIPs": "❌ 清除 IP",
      "removeTGUser": "❌ 移除 Telegram 用户",
      "selectTGUser": "👤 选择 Telegram 用户",
      "selectOneTGUser": "👤 选择一个 Telegram 用户：",
      "resetTraffic": "📈 重置流量",
      "resetExpire": "📅 更改到期日期",
      "ipLog": "🔢 IP 日志",
      "ipLimit": "🔢 IP 限制",
      "setTGUser": "👤 设置 Telegram 用户",
      "toggle": "🔘 启用/禁用",
      "custom": "🔢 自定义",
      "confirmNumber": "✅ 确认: {{ .Num }}",
      "confirmNumberAdd": "✅ 确认添加：{{ .Num }}",
      "limitTraffic": "🚧 流量限制",
      "getBanLogs": "禁止日志",
      "allClients": "所有客户",
      "addClient": "添加客户",
      "submitDisable": "提交为禁用 ☑️",
      "submitEnable": "提交为启用 ✅",
      "use_default": "🏷️ 使用默认",
      "change_id": "⚙️🔑 ID",
      "change_password": "⚙️🔑 密码",
      "change_email": "⚙️📧 邮箱",
      "change_comment": "⚙️💬 评论",
      "change_flow": "⚙️🚦 Flow",
      "ResetAllTraffics": "重置所有流量",
      "SortedTrafficUsageReport": "排序的流量使用报告"
    },
    "answers": {
      "successfulOperation": "✅ 成功！",
      "errorOperation": "❗ 操作错误。",
      "getInboundsFailed": "❌ 获取入站信息失败。",
      "getClientsFailed": "❌ 获取客户失败。",
      "canceled": "❌ {{ .Email }}：操作已取消。",
      "clientRefreshSuccess": "✅ {{ .Email }}：客户端刷新成功。",
      "IpRefreshSuccess": "✅ {{ .Email }}：IP 刷新成功。",
      "TGIdRefreshSuccess": "✅ {{ .Email }}：客户端的 Telegram 用户刷新成功。",
      "resetTrafficSuccess": "✅ {{ .Email }}：流量已重置成功。",
      "setTrafficLimitSuccess": "✅ {{ .Email }}: 流量限制保存成功。",
      "expireResetSuccess": "✅ {{ .Email }}：过期天数已重置成功。",
      "resetIpSuccess": "✅ {{ .Email }}：成功保存 IP 限制数量为 {{ .Count }}。",
      "clearIpSuccess": "✅ {{ .Email }}：IP 已成功清除。",
      "getIpLog": "✅ {{ .Email }}：获取 IP 日志。",
      "getUserInfo": "✅ {{ .Email }}：获取 Telegram 用户信息。",
      "removedTGUserSuccess": "✅ {{ .Email }}：Telegram 用户已成功移除。",
      "enableSuccess": "✅ {{ .Email }}：已成功启用。",
      "disableSuccess": "✅ {{ .Email }}：已成功禁用。",
      "askToAddUserId": "未找到您的配置！\r\n请向管理员询问，在您的配置中使用您的 Telegram 用户 ChatID。\r\n\r\n您的用户 ChatID：<code>{{ .TgUserID }}</code>",
      "chooseClient": "为入站 {{ .Inbound }} 选择一个客户",
      "chooseInbound": "选择一个入站"
    }
  }
}
